import React from 'react'
import ArrowIcon from '../icons/ArrowIcon'

type MemberSelectorProps = {
  displayValue: string
  onClick: () => void
  isActive?: boolean
}

const MemberSelector: React.FC<MemberSelectorProps> = ({
  displayValue,
  onClick,
  isActive = false
}) => (
  <div
    className={`pfv2-selector pfv2-selector--member ${
      isActive ? 'pfv2-selector--active' : ''
    }`}
    onClick={onClick}
  >
    <div
      className={`pfv2-selector-value pfv2-selector-value--member ${
        isActive ? 'pfv2-selector-value--active' : ''
      }`}
    >
      <span dangerouslySetInnerHTML={{ __html: displayValue }} />
    </div>
    <ArrowIcon isActive={isActive} />
  </div>
)

export default MemberSelector
